/**
 * Capitalize the first letter in a string.
 *
 * @param {string} string The string to capitalize.
 * @return {string}
 */
function capitalizeFirstLetter( string ) {

	return string.charAt( 0 ).toUpperCase() + string.slice( 1 );

}


/**
 * Left pad a number with zeros.
 *
 * @param {int} number The number to pad.
 * @param {int} length The desired length of the number.
 * @return {string}
 */
function zeroPadNumber( number, length ) {

	return number.toString().padStart( length, '0' );

}


/**
 * Convert a url into a nice clean string.
 *
 * @param {string} name The name to convert into a nice string.
 * @return {string}
 */
function urlString( name ) {

	if ( !name ) {
		return '';
	}

	return name
		.replace( /[^a-z0-9]/gi, ' ' ) // Ensure only valid characters.
		.trim() // Trim whitespace.
		.replace( /  +/g, ' ' ) // Remove duplicate spaces.
		.replace( / +/g, '-' ) // Replace spaces with a dash.
		.toLowerCase(); // Lowercase.

}